import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { handleFetchError } from 'src/Libs/api/utils'
import fromDtoToFullBridgeConverterModelTransformer from '../transformers/from-dto-to-full-bridge-converter-model.transformers'
import { FullBridgeConverterDto } from '../dto/full-bridge-converter.dto'
import { FullBridgeConverter } from '../models'
import { TFunction } from 'i18next'

export const fetchFullBridgeConvertersBySerialNumber = async (
  serialNumber: number | undefined,
  authFetch: AuthFetchWithResponse,
  t: TFunction
): Promise<ApiResult<FullBridgeConverter[]>> => {
  try {
    const response = await authFetch<FullBridgeConverterDto[]>({
      path: `storages/${serialNumber}/hardware/dcdcs`,
      method: 'GET',
    })

    if (response.status === StatusCodes.OK) {
      const data = fromDtoToFullBridgeConverterModelTransformer(response.data, t)

      return new ApiResult<FullBridgeConverter[]>(data)
    }

    return new ApiResult<FullBridgeConverter[]>(null, true)
  } catch (error) {
    return handleFetchError<FullBridgeConverter[]>(error)
  }
}
